/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 */

export const DONE_FETCHING_SHORT_TERM_POLICIES =
  '@@nzr/shortTermPolicies/DONE_FETCHING_SHORT_TERM_POLICIES'
export const ERROR_FETCHING_SHORT_TERM_POLICIES =
  '@@nzr/shortTermPolicies/ERROR_FETCHING_SHORT_TERM_POLICIES'
export const RECEIVE_SHORT_TERM_POLICIES = '@@nzr/shortTermPolicies/RECEIVE_SHORT_TERM_POLICIES'
export const START_FETCHING_SHORT_TERM_POLICIES =
  '@@nzr/shortTermPolicies/START_FETCHING_SHORT_TERM_POLICIES'
